export default "__VITE_ASSET__i1b7tCYJ__"